import React, { useState } from "react";
import ExpandableSection from "../../../../components/ExpandableSection";
import AssetAllocationPopup from "./AssetAllocationPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faUser,
  faChair,
  faCouch,
  faTimes
} from "@fortawesome/free-solid-svg-icons";

export default function ProjectPeople(props) {

	var {
	   people,
	   onSelectPerson
	 } = props;	
	
  var [expanded, setExpanded] = useState(true);
  
  var availableAssets = [
    { id: 101, type: "Laptop", name: "Dell XPS 13", serial: "DX13-8831" },
    { id: 102, type: "Monitor", name: 'Dell 27" 4K', serial: "U2720Q-1120" },
    { id: 103, type: "Phone", name: "iPhone 14", serial: "IP14-9910" },
    { id: 104, type: "Headset", name: "Jabra Evolve2 65", serial: "JB65-2201" }
  ];

  var unallocatedAssets = [
    { id: 201, type: "Laptop", name: "Lenovo ThinkPad T14", serial: "T14-7744" },
    { id: 202, type: "Monitor", name: 'HP 24" Monitor', serial: "HP24-5542" },
    { id: 203, type: "Keyboard", name: "Logitech MX Keys", serial: "MXK-3109" }
  ];

  var assignedAssets = [
    { id: 102, type: "Monitor", name: 'Dell 27" 4K', serial: "U2720Q-1120" }
  ];

  var [showAssetPopup, setShowAssetPopup] = useState(false);
  var [selectedPerson, setSelectedPerson] = useState(null);
  
  function openAssetAllocation(person) {
    setSelectedPerson(person);
    setShowAssetPopup(true);
  }
  
  const styles = {

    /* -------------------------------------------------
       CONTAINER & HEADER
    ------------------------------------------------- */

    container: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
      overflow: "hidden",
      width: "100%"
    },

    header: {
      padding: "16px 20px",
      borderBottom: "1px solid #e6e6e6",
      background: "linear-gradient(180deg, #FFFFFF 0%, #E7E9EC 100%)"
    },

    title: {
      fontSize: "18px",
      fontWeight: 600
    },

    subTitle: {
      fontSize: "12px",
      color: "#666"
    },

    /* -------------------------------------------------
       GRID HEADER
    ------------------------------------------------- */

    peopleGridHeader: {
      display: "grid",
      gridTemplateColumns: "2fr 1.5fr 1.5fr 1fr 1fr",
      padding: "10px 12px",
      fontSize: "12px",
      fontWeight: 600,
      color: "#555",
      background: "#f4f6f8",
      borderBottom: "1px solid #dfe3e8"
    },

    /* -------------------------------------------------
       LIST / ROWS
    ------------------------------------------------- */

    list: {
      flex: 1,
      overflowY: "auto"
    },

    peopleRow: {
      display: "grid",
      gridTemplateColumns: "2fr 1.5fr 1.5fr 1fr 1fr",
      padding: "12px",
      alignItems: "center",
      borderBottom: "1px solid #e6e9ee",
	  fontSize:'12px'
    },

    peopleRowAlt: {
      background: "#f8fafc"
    },

    rowHover: {
      background: "#f7faff"
    },

    /* -------------------------------------------------
       CELLS
    ------------------------------------------------- */

    nameCell: {
      fontWeight: 'bold'
    },

    editCell: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    },

    editIcon: {
      color: "#lightgrey",
      fontSize: "12px",
      cursor: "pointer",
      opacity: 0.85
    },

    /* -------------------------------------------------
       DESK STATES
    ------------------------------------------------- */

    deskAssigned: {
      color: "#222"
    },

    deskUnallocated: {
      color: "#d93025"
    },

    /* -------------------------------------------------
       STATUS PILLS
    ------------------------------------------------- */

    statusPill: {
	  display:'flex',
      padding: "4px 10px",
      borderRadius: "7px",
      fontSize: "12px",
	  alignItems:'center',
	  justifyContent:'space-around',
	  minWidth:'70px'
    },

    statusAssigned: {
      background: "#006600",
      color: "white"
    },

    statusPending: {
		background: "#996600",
	     color: "white"
    },

    statusUnallocated: {
		background: "#990000",
		color: "white"
    },

    /* -------------------------------------------------
       EMPTY STATE
    ------------------------------------------------- */

    empty: {
      padding: "40px",
      textAlign: "center",
      color: "#777"
    }

  };



  return (
    <ExpandableSection
      title="People"
      buttonLabel="New Person"
      onButtonClick={function () {
        props.setShowMovePopup(true);
      }}
    >
	<div style={styles.container}>

	      {/* HEADER */}
	      <div style={styles.header}>
	        <div style={styles.title}>People</div>
	        <div style={styles.subTitle}>
	          {people.length} records
	        </div>
	      </div>

	      {/* TABLE HEADER */}
		  <div style={styles.peopleGridHeader}>
		    <div>Name</div>
		    <div>Department</div>
		    <div>Desk</div>
		    <div>Assets</div>
		    <div>Status</div>
		  </div>

		  {people.map(p => (
		    <div key={p.id} style={styles.peopleRow}>
		      <div style={styles.nameCell}>{p.name}</div>
		      <div>{p.department}</div>

		      <div style={styles.editCell}>
			  <FontAwesomeIcon icon={faPen} style={styles.editIcon} />
		        <span
		          style={p.deskCode ? styles.deskAssigned : styles.deskUnallocated}
		        >
		          {p.deskCode || "Unallocated"}
		        </span>
		        
		      </div>

		      <div style={styles.editCell}>
			  <FontAwesomeIcon
			    icon={faPen}
			    style={styles.editIcon}
			    title="Edit asset allocation"
			    onClick={function () { openAssetAllocation(p); }}
			  />
		        <span>{p.assets}</span>
		       
		      </div>

		      <div>
		        <span
		          style={{
		            ...styles.statusPill,
		            ...(p.status === "Assigned"
		              ? styles.statusAssigned
		              : p.status === "Pending"
		              ? styles.statusPending
		              : styles.statusUnallocated)
		          }}
		        >
		          {p.status}
		        </span>
		      </div>
		    </div>
		  ))}


			
	    </div>
		<AssetAllocationPopup
		    open={showAssetPopup}
		    person={selectedPerson}
		    floorLabel="HQ Building • Floor 1"
		    availableAssets={availableAssets}
		    assignedAssets={assignedAssets}
		    unallocatedAssets={unallocatedAssets}
		    onClose={function () { setShowAssetPopup(false); }}
		    onSave={function (personId, assignedIds) {
		      console.log("SAVE", personId, assignedIds);
		      setShowAssetPopup(false);
		    }}
		  />
    </ExpandableSection>
  );
}

